module.exports = __webpack_public_path__ + "img/img-67.ea22eb5b.png";